export function b64toBlob (b64Data, contentType = '', sliceSize = 512) {
  if (!b64Data) {
    return 'error'
  } else {
    const byteCharacters = window.atob(b64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)

      byteArrays.push(byteArray)
    }

    const blob = new window.Blob(byteArrays, { type: contentType })
    return blob
  }
}

export function openBlob (blob, fileName) {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE workaround
    window.navigator.msSaveOrOpenBlob(blob, fileName)
  } else {
    var URL = window.URL || window.webkitURL
    const blobURL = URL.createObjectURL(blob)

    if (navigator.userAgent.match(/(iPhone|iPad)/i)) {
      // iOS ignores programmatic clicks on link elements
      // and won't execute window.open statements, so our
      // only choice is to set the current window location
      // to the blob URL. This could be fixed in the future
      // by exposing a URL for each file instead of returning
      // the file data from the API.
      window.location.href = blobURL
    } else {
      // All other browsers should allow a programmatic click:
      const downloadLink = document.createElement('a')
      downloadLink.download = fileName
      downloadLink.innerHTML = 'Download File'
      downloadLink.href = blobURL
      downloadLink.onclick = destroyDowloadLink
      downloadLink.style.display = 'none'
      document.body.appendChild(downloadLink)
      downloadLink.click()
    }

    // Important: we should revoke the object URL but we cannot
    // becasue we don't know if we're finished working with it yet.
    // URL.revokeObjectURL(blobURL)
  }
}

function destroyDowloadLink (event) {
  document.body.removeChild(event.target)
}



// WEBPACK FOOTER //
// ./src/util/BlobHelpers.js